var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "101.000000pt",
    height: "101.000000pt",
    viewBox: "0 0 101.000000 101.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,101.000000) scale(0.100000,-0.100000)",
    fill: "#4173C4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420 1003 c-145 -23 -297 -135 -364 -267 -137 -275 -12 -594 279 -706 87 -34 254 -34 340 0 149 58 248 156 305 305 34 87 34 253 0 340 -90 233 -318 367 -560 328z m301 -305 c-64 -146 -104 -221 -137 -257 -35 -39 -120 -86 -271 -152 l-42 -18 8 22 c5 12 34 74 64 138 70 145 101 174 268 252 68 31 125 57 126 57 1 0 -6 -19 -16 -42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.0464c48cd469049e3fc00fd9a9008c72.svg";
export { ForwardRef as ReactComponent };